// axiosInstance.js
import axios from "axios";
import config from "../config";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: config.baseURL,
  timeout: 1000 * 60 * 10,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const user = localStorage.getItem("user");
    if (user) {
      try {
        const roles = JSON.parse(user)?.roles;
        if (Array.isArray(roles) && roles.length) {
          config.headers["X-Role"] = roles
            .map((role) => (typeof role === "string" ? role : role?.name))
            .filter(Boolean)
            .join(",");
        }
      } catch (e) {
        // Ignore malformed user in localStorage
      }
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Completely suppress canceled requests (no logs, no rejection)
    if (axios.isCancel(error) || error.code === "ERR_CANCELED") {
      return new Promise(() => {}); // Suppress error entirely
    }

    const status = error.response?.status;
    const errorMessage = error?.response?.data?.message || "An error occurred";

    if (status === 401) {
      localStorage.clear();
      if (window?.location?.pathname !== "/login") {
        window.location.href = "/login";
      }
    } else if (!error.config?.suppressErrorToast) {
      if (error.message !== "canceled") {
        toast.error(errorMessage);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
